import React , {useState} from 'react';
import './index.less';

import LogoUrl from './logo.jpeg';

import Icon from './../basic-icon';

import * as Api from './../../api';
import * as session from './../../utils/session';
import Modal from 'antd/lib/modal/Modal';
export default (props) => {
    const [visible, setVisible] = useState(false);
    const handleCancel = () => {
        setVisible(false)
    }
    return (
        <div className="header">
            <div className="container">
                <div className="top-menu">
                   <a href="http://124.88.188.194:9080/admin/#/" rel="opener" target="_blank"><Icon type="icon-logistic-logo"></Icon>数据中心</a> 
                      {/* <a onClick={()=>{
                        setVisible(true)
                    }} ><Icon type="icon-atm-away"></Icon>公众号</a> 
                    <a href="http://172.16.9.53/admin/#/user/register" target="_blank"><Icon type="icon-online-tracking"></Icon>入盟申请</a> */}
                    {
                        props.username ? 
                        (<><span>欢迎:{props.username}</span>
                        <a onClick={() => {
                            Api.logout().then(() => {
                                session.remove();
                                props.logout();
                            });
                        }}>退出</a></>) : 
                        (<a onClick={() => {
                            props.setLoginModalVisiable(true, false);
                            props.refreshKaptcha();
                        }}><Icon type="icon-office-supplies-fill"></Icon>登陆</a>)
                    }
                    
                    
                </div>
                <h1 className="logo"><a href={`${Api.webUrl}/`}><img src={LogoUrl}></img><h2>新疆应用</h2></a></h1>
            </div>
            <Modal
                title="关注公众号"
                visible={visible ? visible : false}
                okText={'确定'}
                cancelText = {'关闭'}
                onOk = {handleCancel}
                onCancel={handleCancel}
                >
                     <div  style={{textAlign:'center'}}><img src={'http://www.ciqa.org.cn/images/CIQAewm.png'}></img></div>
                    {/* <p><Image width={'200px'} height={'200px'} src={'http://www.ciqa.org.cn/images/CIQAewm.png'}/></p> */}
            </Modal>
        </div>
    );
}